import { render, staticRenderFns } from "./IdCardIcon.vue?vue&type=template&id=67f9ab1f&"
import script from "./IdCardIcon.vue?vue&type=script&lang=js&"
export * from "./IdCardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports